export const RESTORE_PHONENUMBER = '/restore-phonenumber';
